import api from "./api";

const ProjectEstimatesService = {
  getAllProjectEstimates: async (
    companyId,
    pageNumber,
    noofRows,
    search = "",
    employeeId = "",
    roleId = "",
    projectId = "",
    storeId = "",
    locationId = "",
    itemCategoryId = ""
  ) => {
    let url = `/projectEstimates/getAll/${companyId}?pageNumber=${pageNumber}&noofRows=${noofRows}&search=${encodeURIComponent(search)}&employeeId=${employeeId}&roleId=${roleId}`;
    if (projectId) url += `&projectId=${projectId}`;
    if (storeId) url += `&storeId=${storeId}`;
    if (locationId) url += `&locationId=${locationId}`;
    if (itemCategoryId) url += `&itemCategoryId=${itemCategoryId}`;
    const res = await api.get(url);
    return res.data;
  },

  saveProjectEstimate: async (data) => {
    return api.post("/projectEstimates/save", data);
  },

  getById: async (id) => {
    return api.get(`/projectEstimates/getById/${id}`);
  },

  updateProjectEstimate: async (id, data) => {
    return api.put(`/projectEstimates/update/${id}`, data);
  },

  deleteProjectEstimate: async (id) => {
    return api.delete(`/projectEstimates/${id}`);
  },

  updateStatus: async (id) => {
    return api.put(`/projectEstimates/updatestatus/${id}`);
  }
};

export default ProjectEstimatesService;
